@if (showReminder()) {
  <div
    class="fixed left-1/2 transform -translate-x-1/2 top-[85%] bg-brand-500 text-white rounded-lg shadow-lg p-6 max-w-md z-40">
    <p class="mb-4">Keep your profile up to date to ensure you get the best experience tailored to your preferences!</p>
    <a
      class="bg-white text-brand-500 font-semibold py-2 px-4 text-xs rounded-sm hover:bg-gray-200"
      [queryParams]="{ tab: 5 }"
      [routerLink]="['/user/dashboard']">
      Update Profile
    </a>
    <button class="absolute top-2 right-2 text-white font-bold" (click)="hideReminder()">X</button>
  </div>
}
